// A very basic wrapper around a DOM Element.
class DomElement<E extends HTMLElement> {
  element: E;

  constructor(element: E) {
    this.element = element;
  }
}

export default DomElement;
